import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'; 
import { db } from '../../firebase';
import { collection, getDocs, query, orderBy, onSnapshot } from 'firebase/firestore';

// --- === UPDATE KORA HOYECHE: formatMonth Function === ---
// Ei function-ti ekhon "YYYY-MM" format-ke "JANUARY 25"-e porinoto korbe
const formatMonth = (yearMonthString) => { // e.g., "2025-01"
    if (!yearMonthString || yearMonthString.split('-').length < 2) return "Invalid Date";
    
    const [year, month] = yearMonthString.split('-');
    // Notun Date object toiri kora (month 0-indexed hoy, tai 1 biyog kora hocche)
    const date = new Date(year, parseInt(month) - 1, 1); 
    
    const monthName = date.toLocaleString('en-US', { month: 'long' }).toUpperCase();
    const yearShort = date.getFullYear().toString().slice(-2); // 2025 -> "25"
    
    return `${monthName} ${yearShort}`;
};
// --------------------------------------------------------

// Helper function (oporibortito)
const formatCurrency = (num) => {
  if (typeof num !== 'number') { num = parseFloat(num || 0); }
  return new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
};


const Invoices = () => {
    const [allInvoices, setAllInvoices] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [loading, setLoading] = useState(true); 
    
    // (Search States - oporibortito)
    const [selectedCompany, setSelectedCompany] = useState('');
    const [invoiceNoSearch, setInvoiceNoSearch] = useState('');
    const [awbNoSearch, setAwbNoSearch] = useState('');
    // ----------------------------------
    
    // (useEffect - oporibortito)
    useEffect(() => {
        // 1. Company List Load korun
        const fetchCompanies = async () => {
            try {
                const companiesSnapshot = await getDocs(query(collection(db, 'companies'), orderBy('name')));
                setCompanies(companiesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
            } catch (error) {
                console.error("Error fetching companies: ", error);
            }
        };
        fetchCompanies();

        // 2. Invoices List-er jonno REAL-TIME listener setup korun
        setLoading(true);
        const invoicesQuery = query(collection(db, 'invoices'), orderBy('invoiceYearMonth', 'desc'));

        const unsubscribe = onSnapshot(invoicesQuery, (querySnapshot) => {
            const invoicesList = querySnapshot.docs.map(doc => ({ 
                id: doc.id, 
                ...doc.data() 
            }));
            setAllInvoices(invoicesList);
            setLoading(false);
        }, (error) => {
            console.error("Error fetching invoices real-time: ", error);
            setLoading(false);
        });

        return () => unsubscribe();
        
    }, []); 
    // -----------------------------------------------------------------


    // (Filtering Logic - oporibortito)
    const filteredInvoices = allInvoices.filter(invoice => {
        const searchInvNo = invoiceNoSearch.toLowerCase();
        const searchAwb = awbNoSearch.toLowerCase();

        const companyMatch = selectedCompany === '' || invoice.companyName === selectedCompany;

        const invoiceNoMatch = searchInvNo === '' || 
            (invoice.invoiceNo && invoice.invoiceNo.toLowerCase().includes(searchInvNo));

        const awbMatch = searchAwb === '' || 
            (invoice.items && invoice.items.some(item => 
                item.awbNo && item.awbNo.toLowerCase().includes(searchAwb)
            ));

        return companyMatch && invoiceNoMatch && awbMatch;
    });
    // ------------------------------------


    // --- === UPDATE: Grouping Logic === ---
    const groupedInvoices = filteredInvoices.reduce((acc, invoice) => {
        // Ekhon `invoiceYearMonth` (e.g., "2025-01") use kora hocche
        const monthYear = invoice.invoiceYearMonth ? formatMonth(invoice.invoiceYearMonth) : 'Uncategorized'; 
        
        if (!acc[monthYear]) {
            acc[monthYear] = [];
        }
        acc[monthYear].push(invoice);
        return acc;
    }, {}); 
    // ----------------------------------

    return (
        <div className='invoices-container'>
            <p className='new-invoice-heading'>Invoices</p>

            {/* (Filter Section - oporibortito) */}
            <div className='form-section invoice-filters'>
                <h3>Filter Invoices</h3>
                
                <div className='form-grid' style={{gridTemplateColumns: '1fr 1fr 1fr', alignItems: 'flex-end', gap: '15px'}}>
                    {/* 1. Company Filter */}
                    <div>
                        <label style={{margin: 0}}>By Company</label>
                        <select 
                            value={selectedCompany} 
                            onChange={(e) => setSelectedCompany(e.target.value)}
                        >
                            <option value="">All Companies</option>
                            {companies.map(company => (
                                <option key={company.id} value={company.name}>
                                    {company.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* 2. Invoice No Search */}
                    <div>
                        <label style={{margin: 0}}>By Invoice No.</label>
                        <input 
                            type="text"
                            value={invoiceNoSearch}
                            onChange={(e) => setInvoiceNoSearch(e.target.value)}
                            placeholder="Search Invoice No (e.g., INV-1001)..."
                        />
                    </div>

                    {/* 3. AWB No Search */}
                    <div>
                        <label style={{margin: 0}}>By AWB No.</label>
                        <input 
                            type="text"
                            value={awbNoSearch}
                            onChange={(e) => setAwbNoSearch(e.target.value)}
                            placeholder="Search AWB No..."
                        />
                    </div>
                </div>
            </div>
            {/* ---------------------------------- */}
            
            
            {/* --- === UPDATE: Invoice List Table === --- */}
            <div className='invoice-list'>
                {loading ? <p>Loading invoices...</p> : (
                    Object.keys(groupedInvoices).map(monthYear => (
                        <div key={monthYear} className='month-group'>
                            {(invoiceNoSearch === '' && awbNoSearch === '' && selectedCompany === '') && (
                                <h2>{monthYear}</h2> // Ekhon "JANUARY 25" dekhabe
                            )}
                            
                            <table className='invoice-preview-table'>
                                <thead>
                                    <tr>
                                        <th>Invoice No.</th>
                                        <th>Date</th>
                                        <th>Company Name</th>
                                        {/* --- UPDATE: Column Header Poriborton --- */}
                                        <th>Month</th>
                                        <th>Total USD</th>
                                        <th>Total BDT (Final)</th>
                                        <th>View/Print</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {groupedInvoices[monthYear].map(invoice => (
                                        <tr key={invoice.id}>
                                            <td style={{color: 'red', fontWeight: 'bold'}}>{invoice.invoiceNo || 'N/A'}</td>
                                            
                                            {/* Eti hocche Invoice Creation Date */}
                                            <td>{invoice.invoiceDate ? new Date(invoice.invoiceDate).toLocaleDateString('en-GB') : 'N/A'}</td>
                                            
                                            <td>{invoice.companyName}</td>
                                            
                                            {/* --- UPDATE: Notun Format e Bill Month --- */}
                                            <td>{invoice.invoiceYearMonth ? formatMonth(invoice.invoiceYearMonth) : 'N/A'}</td>
                                            
                                            <td style={{textAlign: 'right'}}>${formatCurrency(invoice.totalUsd)}</td>
                                            <td style={{textAlign: 'right'}}>৳{formatCurrency(invoice.finalTotalBdt)}</td>
                                            <td className='action-buttons' style={{justifyContent: 'center'}}>
                                                <Link to={`/dashboard/invoices/view/${invoice.id}`} className='view-btn'>
                                                    View
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ))
                )}
                {filteredInvoices.length === 0 && !loading && <p>No invoices found for this selection.</p>}
            </div>
            {/* ------------------------------------- */}
        </div>
    );
}

export default Invoices;